export default "__VITE_ASSET__Q2SPvP30__"